import { toArray } from '../../utils/array'
import { plural } from '../../utils/string'
import { calculateTotalWeight, getFreightClass, getPackageDescription } from '../domain/Commodity'
import { freightClassesMap, type FreightClass } from '../domain/FreightClass'
import { type HandlingUnit } from '../domain/HandlingUnit'
import { type ShippingItem } from '../domain/ShippingItem'
import {
  formatDimension,
  formatDimensionNumber,
  formatPackageTypeLabel,
} from './DimensionsPresenter'

export function formatWeightString(weight: number | string): string {
  weight = Number(weight)

  if (Number.isNaN(weight)) {
    return '-'
  }

  return `${formatDimensionNumber(weight)} ${plural('lb', weight)}`
}

export function formatFreightClass(freightClass?: FreightClass): string {
  if (!freightClass) {
    return '-'
  }
  return freightClassesMap.get(freightClass) || '-'
}

export function formatHandlingUnitTitle(handlingUnit: HandlingUnit): string {
  const itemsLabel = formatPackageTypeLabel({
    count: Number(handlingUnit.packageCount),
    category: 'items',
    description: handlingUnit.packageDescription,
    packageType: handlingUnit.packageType,
  })
  const extraItemsLabel =
    handlingUnit.commoditiesQuantity && handlingUnit.commoditiesQuantity > 1
      ? `+${handlingUnit.commoditiesQuantity - 1}`
      : ''
  return `${itemsLabel} ${extraItemsLabel}`
}

export function formatHandlingUnitDimensionsSummary(handlingUnit: HandlingUnit): string {
  return handlingUnit.length && handlingUnit.width && handlingUnit.height
    ? [
        `${formatDimension(handlingUnit.length)}″ L`,
        `${formatDimension(handlingUnit.width)}″ W`,
        `${formatDimension(handlingUnit.height)}″ H`,
      ].join(' x ')
    : '-'
}

export function formatShippingItemToHandlingUnit(shippingItem: ShippingItem): HandlingUnit {
  return {
    freightClass: getFreightClass(shippingItem.commodities),
    totalWeight: formatWeightString(calculateTotalWeight(shippingItem)),
    height: shippingItem.height,
    width: shippingItem.width,
    length: shippingItem.length,
    uuid: shippingItem.uuid,
    isHazmat: toArray(shippingItem.commodities).some(commodity => commodity.hazmat),
    isStackable: shippingItem.stackable,
    isTurnable: shippingItem.turnable,
    commodities: shippingItem.commodities,
    packageCount: shippingItem.packageCount,
    packageType: shippingItem.packageType,
    packageDescription: getPackageDescription(shippingItem.commodities),
    commoditiesQuantity: shippingItem.commodities?.length,
  }
}
